import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attendance",
  "use": "icon-attendance-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-attendance\">\r\n  <path d=\"M921.6 168.658824h-156.611765v-138.541177h-60.235294v138.541177h-385.505882v-138.541177h-60.235294v138.541177h-162.635294c-36.141176 0-66.258824 30.117647-66.258824 66.258823v686.682353c0 36.141176 30.117647 66.258824 66.258824 66.258824h825.223529c36.141176 0 66.258824-30.117647 66.258824-66.258824V240.941176c6.023529-42.164706-24.094118-72.282353-66.258824-72.282352z m0 72.282352v138.541177h-819.2-6.023529V240.941176h825.223529z m-825.223529 680.658824v-475.858824h825.223529v475.858824h-825.223529z\" />\r\n  <path d=\"M445.741176 752.941176l-138.541176-138.541176-42.164706 36.141176 180.705882 180.705883 307.2-277.082353-42.164705-42.164706z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/attendance.svg
// module id = QlJT
// module chunks = 215